import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfigService } from './api-config.service';
import { ReviewItem, ReviewResponse } from '../../models/review.interface';

@Injectable({
  providedIn: 'root'
})
export class ReviewService {
  private get apiUrl(): string {
    return `${this.apiConfig.apiUrl}/reviews`;
  }

  constructor(
    private http: HttpClient,
    private apiConfig: ApiConfigService
  ) {}

  getAdminReviews(status = 'all', search = '', page = 1, limit = 50): Observable<ReviewResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());

    if (status && status !== 'all') {
      params = params.set('status', status);
    }
    if (search && search.trim()) {
      params = params.set('search', search.trim());
    }

    return this.http.get<ReviewResponse>(`${this.apiUrl}/admin`, { params });
  }

  updateReviewStatus(id: string, status: 'approved' | 'rejected' | 'pending', adminNotes?: string): Observable<{ message: string; review: ReviewItem }> {
    return this.http.put<{ message: string; review: ReviewItem }>(`${this.apiUrl}/admin/${id}/status`, {
      status,
      adminNotes
    });
  }

  deleteReview(id: string): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.apiUrl}/admin/${id}`);
  }
}
